import type { ReactNode } from 'react';
import Header from './Header';

import type { AvatarState } from '../../types/voice';

interface LayoutProps {
  children: ReactNode;
  showHeader?: boolean;
  status?: string;
  avatarState?: AvatarState;
  isListening?: boolean;
  isMuted?: boolean;
  onToggleMute?: () => void;
}

export default function Layout({ 
  children, 
  showHeader = true,

}: LayoutProps) {
  return (
    // Use dvh to behave better on mobile (address bar)
    <div className="h-dvh bg-base-200 flex flex-col overflow-hidden">
      {showHeader && <Header />}

      {/* min-h-0 is critical so children in flex layouts can shrink without forcing page scroll */}
      <main className="flex-1 min-h-0 flex flex-col">
        {children}
      </main>
    </div>
  );
}